import dashboardRoutes from "@/routers/dashboard"

import Vue from "vue"
import Router, { RawLocation } from "vue-router"
import analyticsService from "@/services/analytics/analytics-service"

const originalPush = Router.prototype.push
Router.prototype.push = function push(location: RawLocation) {
  // @ts-ignore
  return originalPush.call(this, location).catch((err: any) => err)
}

Vue.use(Router)

const router = new Router({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [...dashboardRoutes]
})

export function addWildcardRoute() {
  router.addRoute({
    path: "*",
    redirect: { name: "login" }
  })
}

router.afterEach((to, from) => {
  analyticsService.pageViewed({
    name: to.name,
    path: to.path,
    from_name: from ? from.name : null,
    from_path: from ? from.path : null
  })
})

export default router
